<template>
  <PageWrapper :isLoading="isLoading">
    <template #title>
      تاریخچه‌ی کلاس گروهی {{ computedGroupClassName }} با استاد
      {{ computedGroupClassMasterName }}
    </template>
    <CustomTimeline
      :items="timelineItems"
      :reverse="false"
      variant="primary"
    ></CustomTimeline>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    selectedMasterGroupClassId: {
      type: [String, Number],
      required: true,
    },
  },
  mounted() {
    this.getMasterGroupClassStatusDetails();
  },
  data() {
    return {
      isLoading: false,
      groupClassStatusFilters: {
        pageNumber: 1,
        count: 30,
        groupClassMasterId: null,
      },
      groupClassList: null,
      groupClassPersianStatuses: {
        0: {
          title: "جدید",
          variant: "success",
        },
        1: {
          title: "در انتظار تایید",
          variant: "warning ",
        },
        2: {
          title: "در حال ثبت نام",
          variant: "info",
        },
        3: {
          title: "اتمام ظرفیت",
          variant: "primary",
        },
        4: {
          title: "کنسل شده",
          variant: "danger",
        },
        5: {
          title: "به اتمام رسیده",
          variant: "success",
        },
      },
      groupClassStatusList: null,
      timelineItems: null,
    };
  },
  methods: {
    async getMasterGroupClassStatusDetails() {
      try {
        this.groupClassStatusFilters.groupClassMasterId =
          this.selectedMasterGroupClassId;
        this.isLoading = true;
        const _this = this;
        const getMasterGroupStatusDetails = new GetMasterGroupStatusDetails(
          _this
        );
        getMasterGroupStatusDetails.setRequestParam(
          _this.groupClassStatusFilters
        );
        await getMasterGroupStatusDetails.fetch((res) => {
          if (res.isSuccess) {
            _this.groupClassList = res.data;
            _this.timelineItems = res.data.map((item) => {
              return {
                timestamp: Date.parse(item.create_At),
                title: `تغییر وضعیت کلاس از ${
                  this.groupClassPersianStatuses[item.from].title
                } به ${this.groupClassPersianStatuses[item.to].title}`,
                content: item.description,
                variant: this.groupClassPersianStatuses[item.to].variant,
              };
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedGroupClassName() {
      if (
        this.groupClassList &&
        this.groupClassList.length &&
        this.groupClassList[0] &&
        this.groupClassList[0].groupClassName
      ) {
        return this.groupClassList[0].groupClassName;
      }
    },
    computedGroupClassMasterName() {
      if (
        this.groupClassList &&
        this.groupClassList.length &&
        this.groupClassList[0] &&
        this.groupClassList[0].masterFullName
      ) {
        return this.groupClassList[0].masterFullName;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTimeline,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTimeline from "@/views/components/Utils/CustomTimeline.vue";
import { GetMasterGroupStatusDetails } from "@/libs/Api/GroupClass";
</script>
